import { atom } from 'jotai'
import React from 'react'

export { createFieldAtom, createRevRecDependentFieldAtom } from './utils.atoms'
export { secondaryOptionsVisibleAtom } from './secondaryOptionsVisible.atoms'

export const desiredPositionRefAtom = atom<React.RefObject<HTMLElement> | null>(
  null
)
